export const gcpFirewallPaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/firewalls`,
  detail: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/firewalls/${encodeURIComponent(name)}`,
  create: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/firewalls`,
  update: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/firewalls/${encodeURIComponent(name)}`,
  remove: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/firewalls/${encodeURIComponent(name)}`,
};
